module.exports = "https://static.energy5.com/_next/static/images/app-3373e44c2c0798a4373939be5a761b0e.png";